import { getAuth } from "firebase/auth";
import {
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  confirmPasswordReset
} from "firebase/auth";
import { fetchPodSqueezeAPI } from "./apiutils";
import posthog from 'posthog-js';


const registerNewUser = async (userId: string, email: string | null, authProvider: string, isNewsletterChecked: boolean, source: string, intent: string) => {
  try {
      const country = await fetchUserCountry();
      await fetchPodSqueezeAPI('/podsqueeze', 'POST', {
          mode: "new_user",
          userId: userId,
          email: email,
          authProvider: authProvider,
          isNewsletterChecked: isNewsletterChecked,
          source: source,
          intent: intent,
          country: country
      });
  } catch (error) {
      console.error('Error registering new user:', error);
  }
};


const logInWithGoogle = async (isNewsletterChecked: boolean, source?: string, intent?: string) => {
  const googleProvider = new GoogleAuthProvider();
  const auth = getAuth();
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const userSource = source || 'skip';
    const userIntent = intent || 'skip';
    
    posthog.identify(user.uid);

    const isNewUser = user.metadata.creationTime === user.metadata.lastSignInTime;
    
    if (isNewUser) {
      const userProperties = {
        userId: user.uid,
        email: user.email,
        authProvider: 'google',
        signupDate: user.metadata.creationTime,
        signupSource: userSource,
        signupIntent: userIntent,
        isNewsletterSubscribed: isNewsletterChecked,
      };
      
      posthog.people.set(userProperties);
    
      await registerNewUser(user.uid, user.email, "google", isNewsletterChecked, userSource, userIntent);

      if (typeof window !== 'undefined' && typeof (window as any).gr !== 'undefined') {
        (window as any).gr('track', 'conversion', { email: user.email });
      }
      if (typeof window !== 'undefined' && typeof (window as any).tolt !== 'undefined') {
        (window as any).tolt.signup(user.email);
      }
    }
    setTimeout(() => {
      window.location.href = "/squeezed"
    }, 2000);
  } catch (err) {
    console.error(err);
  }
};

const logout = async () => {
  const auth = getAuth();
  console.log('Resetting PostHog identity');
  posthog.reset();
  await signOut(auth);
};

const resetPassword = (e: React.FormEvent, loginEmail:string) => {
  e.preventDefault();
  const auth = getAuth();
  sendPasswordResetEmail(auth, loginEmail)
  .then(function (user) {
    alert('The password reset email was sent to your registered email address.\n\nPlease check your inbox and spam folder.')
  }).catch(function (e) {
    console.log(e)
  })
};

const fetchUserCountry = async (): Promise<string> => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.country_code || 'unknown_country';
  } catch (error) {
    console.error('Error fetching user country:', error);
    return 'unknown_country';
  }
};

const handlePasswordReset = async (oobCode: string, newPassword: string) => {
  const auth = getAuth();
  try {
    await confirmPasswordReset(auth, oobCode, newPassword);
    return { success: true };
  } catch (error) {
    console.error('Error resetting password:', error);
    return { success: false, error };
  }
};

export {
  logout,
  logInWithGoogle,
  registerNewUser,
  resetPassword,
  fetchUserCountry,
  handlePasswordReset
}